import React from "react";
import { Heading, Text, Box, Image } from "rebass";
import styled from "styled-components";
import Img from "react-image";

import Button from "../../components/ui/Button";
import Circle from "../../components/ui/Circle";
import conversationsIcon from "../../img/conversations-icon.svg";
import leads from "../../img/notifcation-leads.jpg";
import registrations from "../../img/notifcation-registrations.jpg";

type Props = {
  siteMetadata: { appUrl: string }
};

const { Fragment } = React;

const IntroPart2 = (props: Props) => (
  <Fragment>
    <Box
      w={[0, 0, 1 / 3]}
      mb={[4, 4, 5, "480px"]}
      pr={[0, 0, "50px", "80px"]}
      mt={[0, 0, "-50px", "-90px", "-170px"]}
    >
      <Image src={leads} alt="leads notification" width="377" is={Img} />
    </Box>

    <Box
      ml="auto"
      w={[1, 1, 1 / 3]}
      mb={[4, 4, 6]}
      mt={[0, 0, 4, "100px"]}
      className="relative"
    >
      <Section2Circles>
        <Section2Circle1 r={8} />
        <Section2Circle2 r={8} />
        <Section2Circle3 r={13} />
        <Section2Circle4 r={5} />
      </Section2Circles>

      <Heading
        color="support2"
        is="h4"
        f={[3, 4, "26px"]}
        mb={[3]}
        className="relative font-light text-right  text-left-desktop"
      >
        <ConversationsIcon
          src={conversationsIcon}
          alt="Conversations icon"
          is={Img}
        />
        Spark conversations with your followers at scale
      </Heading>

      <Text
        color="support1"
        f="15px"
        className="text-right text-left-desktop"
        mb={[4]}
      >
        Break free from those static, text only marketing emails and start real
        conversations with functional and content-rich messages.
      </Text>
      <div className="text-right text-left-desktop">
        <Button is="a" href={props.siteMetadata.appUrl} mb={[4]}>
          GET STARTED FOR FREE
        </Button>
      </div>
    </Box>

    <Box
      w={[1, 1, 1 / 3]}
      mb={["195px", null, 6]}
      px={[0, 0, 3]}
      mt={[0, 0, 6, "180px"]}
    >
      <Image
        src={registrations}
        alt="registrations notification"
        width="458px"
        className="relative"
        is={Img}
      />
    </Box>
  </Fragment>
);

export default IntroPart2;

// Styled Components
const ConversationsIcon = styled(Image)`
  left: -26px;
  position: absolute;
  top: -64px;
  transform: scale(0.8);

  @media (min-width: 48em) {
    left: -50px;
    top: -75px;
    transform: scale(1);
  }
`;
const Section2Circles = styled.div`
  left: 30px;
  position: absolute;
  top: 230px;
  z-index: 0;

  @media (min-width: 48em) {
    left: 310px;
    top: -80px;
  }

  @media (min-width: 56em) {
    left: 410px;
    top: -80px;
  }
`;

const Section2Circle1 = styled(Circle)`
  left: -25px;
  position: absolute;
  top: -15px;
`;

const Section2Circle2 = styled(Circle)`
  left: 25px;
  position: absolute;
  top: -55px;

  @media (min-width: 56em) {
    left: 55px;
    top: -95px;
  }
`;

const Section2Circle3 = styled(Circle)`
  left: 105px;
  position: absolute;
  top: -35px;

  @media (min-width: 56em) {
    left: 175px;
    top: -55px;
  }
`;

const Section2Circle4 = styled(Circle)`
  left: 125px;
  position: absolute;
  top: 20px;

  @media (min-width: 56em) {
    left: 255px;
    top: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Intro/IntroPart2.jsx